import React, { useEffect, useState } from "react";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai"; // Heart icon
import { FaBed, FaBuilding } from "react-icons/fa"; // Property icons
import { GiHouse } from "react-icons/gi"; // Home icon
import { IoIosShareAlt } from "react-icons/io";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi"; // Arrow icon
import { formatCurrencyUtil, getImageUrl, getUserData } from "../../Utils/localStorageUtils";
import { motion, AnimatePresence } from "framer-motion"; // Import Framer Motion
import { HiChevronDown, HiChevronUp } from "react-icons/hi"; // Import Icons
import { addToShortlist, getUserShortlistedProperties, removeFromShortlist } from "../../services/shortlistService";
import { useToast } from "../../hooks/useToast";
import SharePropertyModal from "../SharePropertyModal/SharePropertyModal";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import { API_BASE_URL, APP_BASE_URL } from "../../Utils/constants";

const SearchResultCardComponent = ({ property, isShortlisted: initialShortlisted }) => {
    const { _id: userId } = getUserData() || {}
    console.log("propertypropertyproperty", property)


    const { showSuccess, showError } = useToast()

    const {goTo} = useCustomNavigate()

    const [isLoading, setIsLoading] = useState(false); // 🔄 Loading state

    const [expanded, setExpanded] = useState(false);
    const [descriptionExpanded, setDescriptionExpanded] = useState(false);
    const [isShortlisted, setIsShortlisted] = useState(initialShortlisted);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false); // Modal state

    if (!property) return null;

    const {
        _id, // Property ID
        basicDetails,
        locationDetails,
        aboutProperty,
        pricingAndOthers,
        mediaFiles,
        postedBy,
        createdAt,
    } = property;




    // Function to get the first available area
    const getAvailableArea = ({ areaDetails }) => {
        if (areaDetails?.superBuildUpArea) {
            return {
                label: "Super Area",
                value: areaDetails.superBuildUpArea,
                unit: areaDetails.superBuildUpAreaUnit,
            };
        }
        if (areaDetails?.buildupArea) {
            return {
                label: "Built-Up Area",
                value: areaDetails.buildupArea,
                unit: areaDetails.buildupAreaUnit,
            };
        }
        if (areaDetails?.carpetArea) {
            return {
                label: "Carpet Area",
                value: areaDetails.carpetArea,
                unit: areaDetails.carpetAreaUnit,
            };
        }
        if (areaDetails?.plotArea) {
            return {
                label: "Plot Area",
                value: areaDetails.plotArea,
                unit: areaDetails.plotAreaUnit,
            };
        }
        return null; // If no area is available
    };


    const selectedArea = getAvailableArea(aboutProperty);




    // Utility function to check if a value exists
    const exists = (value) => value !== undefined && value !== null && value !== "";



    // 🔹 Handle Shortlist Toggle
    const handleShortlistToggle = async (e) => {
        e.stopPropagation(); // 🛑 Prevent click from triggering parent event
        if (!userId) {
            showError("Please log in to shortlist properties!");
            return;
        }

        setIsLoading(true); // Start loading


        try {
            if (isShortlisted) {
                const response = await removeFromShortlist(userId, _id);

                if (response?.success) {
                    setIsShortlisted(false);
                    showSuccess("Removed from shortlist!");
                } else {
                    showError(response?.message || "Failed to remove from shortlist.");
                }
            } else {
                const response = await addToShortlist(userId, _id);

                if (response?.success) {
                    setIsShortlisted(true);
                    showSuccess("Added to shortlist!");
                } else {
                    showError(response?.message || "Failed to add to shortlist.");
                }
            }
        } catch (error) {
            showError("Something went wrong. Try again!");
            console.error("Shortlist Error:", error);
        }
        finally {
            setIsLoading(false); // Stop loading
        }
    };




    const handleShareClick = (e) => {
        e.stopPropagation(); // 🛑 Prevent click from triggering parent event
        setIsShareModalOpen(true);
    };

    const handleOnClose = (e) => {
        e.stopPropagation(); // 🛑 Prevent click from triggering parent event
        setIsShareModalOpen(false);
    };


    return (
        <div 
        className="flex border rounded-lg shadow-md overflow-hidden  bg-white hover:shadow-lg transition-shadow duration-300"
        
        >
            {/* Left Image Section */}
            <div className="w-[24%]  px-3 py-3 border">
                <div className="relative h-[130px] cursor-pointer" onClick={()=>{goTo(`/propertydetail/${_id}`)}}>
                    <img
                        src={getImageUrl(mediaFiles?.[0]?.fileName) || "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2023/04/26/Project-Photo-7-Nature-Homes-Amaltas-Jaipur-5404193_1200_1600_310_462.jpg"} // Default image if not available
                        alt="Property"
                        className="rounded-md w-full h-full object-cover"
                        onError={(e) => { e.target.src = "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2023/04/26/Project-Photo-7-Nature-Homes-Amaltas-Jaipur-5404193_1200_1600_310_462.jpg" }}
                    />

                    <div className="absolute top-2 left-2 bg-black text-white text-[10px] rounded px-2 py-[2px]">

                        {mediaFiles?.length > 0 ? mediaFiles?.length + "+" : "29+ "} Photos {/* Show number of photos */}
                    </div>
                    <div className="absolute bottom-0 bg-black text-white text-[10px] rounded w-full py-1 bg-opacity-50 px-2">
                        Posted: {exists(createdAt) ? new Date(createdAt).toLocaleDateString() : "Jan 20, '25"}
                    </div>
                </div>
            </div>

            {/* Middle Details Section */}
            <div className="w-[56%] px-4 py-3">
                <div className="flex justify-between">
                    <h2 className="text-sm font-medium text-[#303030] cursor-pointer"
                    onClick={()=>{goTo(`/propertydetail/${_id}`)}}
                    >
                        {/* 3 BHK Flat for Sale in Nature Homes Amaltas, Jagatpura, Jaipur */}
                        {exists(basicDetails?.additionalOption?.value) ? `${basicDetails.additionalOption.value} in ` : ""}
                        {locationDetails?.searchLocation}
                    </h2>
                    <div className="flex space-x-3">
                        <div
                            className={`text-gray-400 cursor-pointer ${isLoading ? "opacity-50 pointer-events-none" : ""}`}
                            onClick={ // 🛑 Prevent click from triggering parent event
                                handleShortlistToggle}
                            >
                            {isLoading ? (
                                <div className="animate-spin text-red-500">
                                    ⏳ {/* You can replace this with a spinner icon */}
                                </div>
                            ) : isShortlisted ? (
                                <AiFillHeart className="text-[22px] text-red-500" />
                            ) : (
                                <AiOutlineHeart className="text-[22px] hover:text-red-500" />
                            )}
                        </div>
                        <div className="text-gray-400" onClick={handleShareClick}>
                            <IoIosShareAlt className="text-[24px] inline-block cursor-pointer hover:text-red-500" />
                        </div>
                    </div>
                </div>

                {exists(locationDetails?.apartmentSociety) && (
                    <p className="text-xs underline text-[#606060]">
                        {locationDetails.apartmentSociety}
                    </p>
                )}


                <div className="flex justify-between   mt-3 text-gray-600 text-sm bg-[#e8e8e880] pl-2">
                    <div className="flex flex-col py-3 w-full">
                        <div className="grid grid-cols-3 gap-4">
                            {selectedArea && (
                                <div className="flex items-center space-x-2">
                                    <FaBed className="text-[30px]" />
                                    <div>
                                        <span className="truncate text-[#606060] text-[10px] font-normal">{selectedArea.label}</span>
                                        <p className="font-medium text-xs leading-none truncate text-[#303030]">
                                            {selectedArea.value} {selectedArea.unit}
                                        </p>
                                    </div>
                                </div>
                            )}
                            {(exists(aboutProperty?.availabilityStatus) && exists(aboutProperty?.possessionBy?.expectedBy)) ? (
                                <div className="flex items-center space-x-2">
                                    <FaBed className="text-[30px]" />
                                    <div>
                                        <span className="truncate text-[#606060] text-[10px] font-normal">{aboutProperty?.availabilityStatus}</span>
                                        <p className="font-medium text-xs truncate leading-none text-[#303030]">Poss. by {aboutProperty?.possessionBy?.expectedBy}</p>
                                    </div>
                                </div>
                            )
                                : aboutProperty?.availabilityStatus ? (
                                    <div className="flex items-center space-x-2">
                                        <FaBed className="text-[30px]" />
                                        <div>
                                            <span className="truncate text-[#606060] text-[10px] font-normal">Status</span>
                                            <p className="font-medium text-xs truncate leading-none text-[#303030]">{aboutProperty?.availabilityStatus}</p>
                                        </div>
                                    </div>
                                ) : null
                            }
                            {exists(aboutProperty?.floorDetails?.propertyOnFloor) && exists(aboutProperty?.floorDetails?.totalFloor) && (
                                <div className="flex items-center space-x-2">
                                    <FaBed className="text-[30px]" />
                                    <div>
                                        <span className="truncate text-[#606060] text-[10px] font-normal uppercase">Floor</span>
                                        <p className="font-medium text-xs leading-none truncate text-[#303030]">{`${aboutProperty?.floorDetails?.propertyOnFloor} out of ${aboutProperty?.floorDetails?.totalFloor}`}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <AnimatePresence>
                            {expanded && (
                                <motion.div
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: "auto" }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.4, ease: "easeInOut" }}
                                    className="overflow-hidden mt-2"
                                >
                                    <div className="grid grid-cols-3 gap-4 mt-2">
                                        {exists(aboutProperty?.furnishings?.status) && (
                                            <div className="flex items-center space-x-2">
                                                <FaBed className="text-[30px]" />
                                                <div>
                                                    <span className="truncate text-[#606060] text-[10px] font-normal uppercase">Furnishing</span>
                                                    <p className="font-medium text-xs leading-none truncate text-[#303030]">
                                                        {aboutProperty?.furnishings?.status}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        {exists(aboutProperty?.roomDetails?.bathrooms) && (
                                            <div className="flex items-center space-x-2">
                                                <FaBed className="text-[30px]" />
                                                <div>
                                                    <span className="truncate text-[#606060] text-[10px] font-normal uppercase">Bathroom</span>
                                                    <p className="font-medium text-xs truncate leading-none text-[#303030]">{aboutProperty?.roomDetails?.bathrooms}</p>
                                                </div>
                                            </div>
                                        )}
                                        {exists(aboutProperty?.roomDetails?.balconies) && (
                                            <div className="flex items-center space-x-2">
                                                <FaBed className="text-[30px]" />
                                                <div>
                                                    <span className="truncate text-[#606060] text-[10px] font-normal">Balcony</span>
                                                    <p className="font-medium text-xs leading-none truncate text-[#303030]">{aboutProperty?.roomDetails?.balconies}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    {/* Toggle Button */}
                    {(
                        exists(aboutProperty?.furnishings?.status) ||
                        exists(aboutProperty?.roomDetails?.bathrooms) ||
                        exists(aboutProperty?.roomDetails?.balconies)
                    ) && (
                            <div className="w-[24px] h-auto  border-l shadow flex items-center justify-center cursor-pointer ml-4" onClick={() => setExpanded(!expanded)}>
                                {expanded ? (
                                    <HiOutlineChevronUp className="text-gray-500 text-[16px]" />
                                ) : (
                                    <HiOutlineChevronDown className="text-gray-500 text-[16px]" />
                                )}
                            </div>
                        )}
                </div>



                {exists(pricingAndOthers?.OwnershipPriceDetails?.propertyDescription) && <div>
                    {/* Description */}
                    <AnimatePresence>
                        <motion.p
                            initial={{ opacity: 0, height: "2.5rem", overflow: "hidden" }} // Show only one line
                            animate={{ opacity: 1, height: descriptionExpanded ? "auto" : "2.5rem" }} // Expand on click
                            exit={{ opacity: 0, height: "2.5rem" }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            className="mt-3 text-sm text-[#303030] overflow-hidden"
                        >
                            {pricingAndOthers?.OwnershipPriceDetails?.propertyDescription}
                        </motion.p>
                    </AnimatePresence>

                    {/* Expand/Collapse Button with Icon */}
                    <button
                        onClick={() => setDescriptionExpanded(!descriptionExpanded)}
                        className="mt-2 flex items-center text-blue-600 text-sm font-medium hover:underline focus:outline-none transition-all duration-300"
                    >
                        {descriptionExpanded ? "Read Less" : "Read More"}
                        {descriptionExpanded ? (
                            <HiChevronUp className="ml-1 text-[16px]" />
                        ) : (
                            <HiChevronDown className="ml-1 text-[16px]" />
                        )}
                    </button>
                </div>}
            </div>

            {/* Right Pricing and CTA Section */}
            <div className="w-[20%] text-center bg-[#f5f5f5] flex flex-col justify-between px-5 py-4">
                <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                        {pricingAndOthers?.OwnershipPriceDetails?.expectedPrice
                            ? formatCurrencyUtil(pricingAndOthers?.OwnershipPriceDetails?.expectedPrice)
                            : formatCurrencyUtil(pricingAndOthers?.rentDetails?.expectedRent)}

                    </h3>


                    {basicDetails?.lookingTo === "Sell" &&
                        pricingAndOthers?.OwnershipPriceDetails?.pricePerSqFt &&
                        pricingAndOthers?.OwnershipPriceDetails?.expectedPrice ? (
                        <p className="text-sm text-gray-500">
                            {formatCurrencyUtil(pricingAndOthers?.OwnershipPriceDetails?.pricePerSqFt)} per sqft
                        </p>
                    ) : (
                        (basicDetails?.lookingTo === "Rent / Lease" || basicDetails?.lookingTo === "PG") && (
                            <p className="text-sm text-gray-500 underline">Security Deposit</p>
                        )
                    )}
                </div>
                <div className="space-y-3 mt-4">
                    <button 
                    onClick={()=>{goTo(`/propertydetail/${_id}`)}}
                    className="w-full bg-red-600 text-white text-sm py-1 rounded-full shadow hover:bg-red-700">
                        Contact Agent
                    </button>
                    <button 
                    onClick={()=>{goTo(`/propertydetail/${_id}`)}}
                    className="w-full border border-red-600 text-red-600 text-sm py-1 rounded-full shadow hover:bg-red-50">
                        Enquire Now
                    </button>
                </div>

            </div>

            {/* Share Property Modal */}
            {isShareModalOpen && (
                <SharePropertyModal
                    isOpen={isShareModalOpen}
                    onClose={handleOnClose}
                    shareUrl={`${APP_BASE_URL}/propertydetail/${_id}`} // Dynamic property link
                />
            )}
        </div>
    );
};

export default SearchResultCardComponent;
